import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommitmentGoalSummaryRowComponent } from './commitment-goal-summary-row.component';
import { CmpsCommitmentGoalSummaryComponent } from './commitment-goal-summary.component';

@NgModule({
    declarations: [
        CmpsCommitmentGoalSummaryComponent,
        CmpsCommitmentGoalSummaryRowComponent,
    ],
    imports: [CommonModule, CmpsIconModule],
    exports: [
        CmpsCommitmentGoalSummaryComponent,
        CmpsCommitmentGoalSummaryRowComponent,
    ],
})
export class CmpsCommitmentGoalSummaryModule {}
